import course from './sections/course';
import courses from './sections/courses';
import cta from './sections/cta';
import hero from './sections/hero';

const translations = {
    page: {
        metaTitle: 'Kursy',
        metaDescription: 'Kursy',
    },
    sections: {
        hero,
        courses,
        cta,
        course,
    },
};

export default translations;
